import React from "react";
import Header from "../component/Header";
import CommonBanner from "../component/CommonBanner";
import Footer from "../component/Footer";
import ExploreResultLocations from "../component/ExploreResultLocations";
import CareerList from "../component/CareerList";
import CareerCompanyFeatures from "../component/CareerCompanyFeatures";
import { Col, Container, Form, Row } from "react-bootstrap";
function Career() {
  return (
    <>
      <div className="main career-page">
        <Header />
        <CommonBanner title="Career" />
        <CareerList /> 
        <section className="career-cta-section common-padding d-none">
          <Container>
            <Row>
                <Col md={12}>
                <Form>
                  <Form.Group className="mb-3 form-group">
                    <Form.Label>FirstName <span>*</span></Form.Label>
                    <input className="form-control" type="text" placeholder="First Name" />         
                  </Form.Group>
                  <Form.Group className="mb-3 form-group">
                    <Form.Label>Lastname <span>*</span></Form.Label>
                    <input className="form-control" type="text" placeholder="Last Name" />         
                  </Form.Group>
                  <Form.Group className="mb-3 form-group" controlId="formBasicEmail">
                    <Form.Label>Email Address <span>*</span></Form.Label>
                    <input className="form-control" type="email" placeholder="Email Address" />         
                  </Form.Group>
                  <Form.Group className="mb-3 form-group">
                    <Form.Label>Phone Number <span>*</span></Form.Label>
                    <input className="form-control" type="tel" placeholder="Phone Number" />
                  </Form.Group>
                  <Form.Group className="mb-3 form-group">
                    <Form.Label>Job Title <span>*</span></Form.Label>
                    <input className="form-control" type="text" placeholder="Job Title" />         
                  </Form.Group>
                  <Form.Group className="mb-3 form-group">
                  <Form.Label>Upload File</Form.Label>
                    <div className="file-control">
                      <input className="form-control " type="file" id="ChooseFile" placeholder="No file chosen*" />   
                      <div className='d-flex align-items-center'><Form.Label htmlFor="ChooseFile">Choose File</Form.Label> <span>No file chosen</span></div>
                    </div>
        
                  </Form.Group>
                  <Form.Group className="mb-3 form-group w-full">
                  <Form.Label>Write Bio <span>*</span></Form.Label>
                    <textarea name="" rows={5} placeholder='Tell us about your self'></textarea>        
                  </Form.Group>         
                  <Form.Group className="mb-4 form-group w-full">
                    <div className="check-group">
                        <input id='CheckMeOut' type="checkbox" />
                        <Form.Label className="w-full" htmlFor="CheckMeOut">Yes, I have read and consent to the <a href="">terms and conditions</a>.</Form.Label>                
                    </div>
                  </Form.Group>            
                </Form> 
                </Col>
            </Row>
          </Container>
        </section>
        <CareerCompanyFeatures />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}
export default Career;
